import { Modal, Progress, Typography } from "antd";

import PrimaryButton from "../Forms/PrimaryButton";
import { useNavigate } from "react-router-dom";
import { formatDate, handleRouteNav, numberFormatter } from "../../utils";
import { useSelector } from "react-redux";

const { Title } = Typography;

export default function NewOfferModal({ open, onClose, loading, schemeData }) {
  const desclimar = [
    "Meeting the quantity threshold alone does not guarantee that the scheme will apply.",
    "The scheme may not apply to all products and orders, and there may be other criteria for it to apply.",
    "Some of the additional criteria for this scheme are mentioned as Special Remarks. Please click on ‘View Details’ below to know more.",
    "For any clarifications or further information regarding this scheme, please contact your sales representative.",
  ];

  const navigate = useNavigate();
  const { company_name, role_id } = useSelector((state) => state.auth);

  if (!schemeData?.remarks?.trim()) {
    desclimar.splice(2, 1);
  }
  const sortedVariantSummary =
    [...(schemeData?.variant_summary || [])]
      ?.sort((a, b) => a?.required_quantity - b?.required_quantity)
      .map((a, i) => ({ ...a, index: i + 1 })) || [];
  let currentVariantSummary = sortedVariantSummary?.find((item) => item?.status === "active");

  if (!currentVariantSummary && sortedVariantSummary.every((item) => item?.status == "completed")) {
    currentVariantSummary = sortedVariantSummary?.[sortedVariantSummary?.length - 1];
  } else if (!currentVariantSummary) {
    currentVariantSummary = sortedVariantSummary?.[0];
  }

  let title = "",
    subtitle = "", nameLine = `Hi ${company_name},`;

  switch (currentVariantSummary?.status) {
    case "active":
      title = "Your Scheme Is Still Active";
      subtitle = `Your scheme is still active, and available.
      There are benefits for you, still waiting to be unlocked.
      Don’t miss out!`;
      break;

    case "completed":
      title = "Your Target Has Been Hit!";
      subtitle = `Congratulations! You have successfully achieved your target, for this scheme. If eligible, you may Claim Your Benefits!`;
      break;

    case "inactive":
      title = "New Scheme For You";
      subtitle = `You have a new untapped scheme. To tap into this scheme and its benefits, get started, and Place Orders today!`;
      break;

    default:
      break;
  }

  const getSchemeNavigate = (data) => {
    navigate(handleRouteNav(`/home/scheme-details`, role_id), {
      state: { offerId: data },
    });
  };

  return (
    <Modal
      className="form-css custom-modal"
      open={open}
      footer={null}
      onCancel={onClose}
      width={500}
    >
      <Title level={2} className="font-abhaya mb-2">
        {title}
      </Title>
      <b>{nameLine}</b>
      <p className="whitespace-pre-line">{subtitle}</p>

      <div className="flex gap-4 items-center mt-10">
        <div className="bg-[#F4F4F4] p-2 w-fit" style={{ borderRadius: "24px" }}>
          <img className="min-h-[64px] min-w-[64px]" src="/assets/icons/welcome-logo.png"></img>
        </div>

        <div className="text-left">
          <strong className="text-xl text-[#000]">{schemeData?.title}</strong>
          <div className="text-[#00000080] mt-2">
            {formatDate(schemeData?.from_date)} - {formatDate(schemeData?.to_date)}
          </div>
        </div>
      </div>

      {currentVariantSummary?.status !== "inactive" && (
        <div className="text-left mt-6">
          <div className="text-[#000] mb-2">
            <b>{numberFormatter(currentVariantSummary?.achieved_quantity)}</b> out of{" "}
            <b>{numberFormatter(currentVariantSummary?.required_quantity)}</b>{" "}
            {currentVariantSummary?.quantity_type === "Cases" ? "cases" : "meters"}
          </div>

          <Progress
            percent={currentVariantSummary?.progress_percent}
            showInfo={false}
            strokeWidth={16}
            strokeColor="#a33434"
            trailColor="#A3343426"
            className={currentVariantSummary?.progress_percent >= 100 ? "glow-progress-full" : ""}
          />
        </div>
      )}

      <div className="text-left mt-4">
        <strong className="text-xl text-[#000]">Slab {currentVariantSummary?.index}</strong>

        <div className="flex flex-col mt-4 gap-3">
          <div className="flex gap-3 items-center">
            <img src="/assets/icons/quantity.svg"></img>
            <div className="">
              <div className="text-[#00000080] ">Quantity</div>
              <strong className="text-lg text-[#000] mt-2">
                {numberFormatter(currentVariantSummary?.required_quantity)}{" "}
                {currentVariantSummary?.quantity_type === "Cases" ? "Cases" : "Mtrs"}
              </strong>
            </div>
          </div>

          <div className="flex gap-3 items-center">
            <img src="/assets/icons/incentive.svg"></img>
            <div className="">
              <div className="text-[#00000080] ">Incentive</div>
              <strong className="text-lg text-[#000] mt-2">
                {currentVariantSummary?.credit_value}
              </strong>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-10">
        <div className="flex items-center gap-3 mb-3">
          <h2 className="text-md font-bold text-[#000]">Disclaimers</h2>
        </div>

        <div className="space-y-4">
          {desclimar.map((item, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="flex-shrink-0 mt-1.5">
                <div className="w-2 h-2 bg-[#A33434] rounded-full"></div>
              </div>
              <p className="flex-1 text-left text-gray-600 leading-relaxed text-sm">{item}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex justify-center mt-6">
        <PrimaryButton
          text={"View Details"}
          type="submit"
          loading={loading}
          className="me-[30px]"
          onClick={() => getSchemeNavigate(schemeData?.offer_id)}
        />
      </div>
    </Modal>
  );
}
